import {validMagicArea,type MagicArea} from '../shared/magic-area';
/** Already server-authorized presentation channel; never insert a log row or play roll audio. */
export function handleMagicArea(message: {roll: Record<string,unknown>}): void {
    const roll=message.roll;
    const current=String(window.ftGetActiveEncounterId?.()||'').toUpperCase();
    if(!current||current!==String(roll?.encounter_id||'').toUpperCase())return;
    if(!window.FateTide?.user?.isGM&&Number(roll.roll_private||0)>0&&Number(roll.campaign_permission||0)!==1)return;
    const cue=roll.roll_vfx as Record<string,unknown>|undefined;
    if(!cue||cue.schema!=='ft.ft3d.magic-cue.v1'||!validMagicArea(cue.area as MagicArea|undefined)
        ||String((cue.area as MagicArea).encounterId).toUpperCase()!==current)return;
    document.dispatchEvent(new CustomEvent('ft-magic-area-authorized',{detail:{roll}}));
}
